import axios from "axios";

const { API_BASE_URL } = require("../config");

async function getAllTrips() {
    try {
        const response = await fetch(`${API_BASE_URL}/trips`);
        
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching trips:', error);
    }
}

async function getTripById(id) {
    try {
        const response = await fetch(`${API_BASE_URL}/trips/${id}`);
        
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching trip by ID:', error);
    }
}

async function getTripBySlug(slug) {
    try {
        const response = await fetch(`${API_BASE_URL}/trips/slug/${slug}`);
        
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching trip by ID:', error);
    }
}

async function getTripsByCategory(category, limit = null) {
    try {
        const response = await fetch(`${API_BASE_URL}/trips?filterby=category&filtervalue=${category}`);
        
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching trips by category:', error);
    }
}

async function fetchCategories(type = null) {
    try {
        const response = type != null ? await fetch(`${API_BASE_URL}/categories?type=${type}`) : await fetch(`${API_BASE_URL}/categories`);
        
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching categories:', error);
    }
}

async function createTrip(tripData) {
    try {
        const authToken = localStorage.getItem('authToken');
        const response = await axios.post(`${API_BASE_URL}/trips`, tripData, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }
        });

        
        const data = response.data;
        return data;
    } catch (error) {
        console.error('Error creating trip:', error);
        // throw error;
    }
}

async function updateTrip(id, tripData) {
    try {
        const authToken = localStorage.getItem('authToken');
        const response = await axios.put(`${API_BASE_URL}/trips/${id}`, tripData, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }
        });
        
        const data = response.data;
        return data;
    } catch (error) {
        console.error('Error updating trip:', error);
    }
}   

async function deleteTrip(id) {
    try {
        const authToken = localStorage.getItem('authToken');
        const response = await axios.delete(`${API_BASE_URL}/trips/${id}`, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }
        });
        
        const data = response.data
        return data;
    } catch (error) {
        console.error('Error deleting trip:', error);
    }
}

async function getCategoryById(id) {
    try {
        const response = await fetch(`${API_BASE_URL}/categories/${id}`);

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching category by ID:', error);
    }
}

async function createCategory(categoryData) {
    try {
        const authToken = localStorage.getItem('authToken');
        const response = await axios.post(`${API_BASE_URL}/categories`, categoryData, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }
        });

        const data = response.data;
        return data;
    } catch (error) {
        console.error('Error creating category:', error);
    }
}

async function deleteCategory(id) {
    try {
        const authToken = localStorage.getItem('authToken');
        const response = await axios.delete(`${API_BASE_URL}/categories/${id}`, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }
        }); 
        
        const data = response.data;
        return data;
    } catch (error) {
        console.error('Error deleting category:', error);
    }   
}

async function updateCategory(id, categoryData) {
    try {
        const authToken = localStorage.getItem('authToken');
        const response = await axios.put(`${API_BASE_URL}/categories/${id}`, categoryData, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }   
        });
        
        const data = response.data;
        return data;
    } catch (error) {
        console.error('Error updating category:', error);
    }   
}

async function fetchDashboardStats() {
    try {
        const authToken = localStorage.getItem('authToken');
        const response = await axios.get(`${API_BASE_URL}/dashboard/stats`, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }
        });
        
        const data = response.data;
        return data;
    } catch (error) {
        console.error('Error fetching dashboard stats:', error);
    }
}

export { getAllTrips, getTripById, getTripBySlug, getTripsByCategory, getCategoryById, fetchCategories, createTrip, updateTrip, deleteTrip, createCategory, deleteCategory, updateCategory, fetchDashboardStats };